import {
  Product,
  ProductFilterModel,
  useCurrentWorkspace,
  useProductFilter,
} from '@gripp/shared-logic';
import { SelectionStatus, SlideAction, useSlideLayout, ViewMode } from '@gripp/shared-ui';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { ProductsList, SelectedProductRow } from './productsList';

type ProductsComponentProps = {
  onRowsSelectedChange?: (rows: SelectedProductRow[]) => void;
  selectedRowIds?: string[];
  selectionStatus?: SelectionStatus;
  onSelectionStatusChange?: (status: SelectionStatus) => void;
};

export const ProductsComponent = ({
  onRowsSelectedChange,
  selectedRowIds,
  selectionStatus,
  onSelectionStatusChange,
}: ProductsComponentProps) => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();
  const { data: productFilter } = useProductFilter();
  const currentWorkspace = useCurrentWorkspace();
  const impersonatingWorkspace = useCurrentWorkspace(true);

  const showCheckboxColumn = useMemo(
    () => !!impersonatingWorkspace,
    [impersonatingWorkspace]
  );

  const filter = useMemo(() => {
    const filter: ProductFilterModel =
      productFilter ?? new ProductFilterModel();
    filter.workspaceId = currentWorkspace?.id;
    return filter.getGraphQLFilter();
  }, [productFilter, currentWorkspace?.id]);

  const onProductClick = async (product: Product) => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate(`/products/${product.id}`);
  };

  return (
    <View style={styles.productsContainer}>
      <ProductsList
        filter={filter}
        showCheckboxColumn={showCheckboxColumn}
        onProductClick={onProductClick}
        onRowsSelectedChange={onRowsSelectedChange}
        selectedRowIds={selectedRowIds}
        selectionStatus={selectionStatus}
        onSelectionStatusChange={onSelectionStatusChange}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  productsContainer: {
    flex: 1,
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: -1,
  },
});
